import { Component, OnInit } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { IBreadcrumbItem } from 'src/app/interfaces/breadcrumb/breadcrumb.interface';
import { NoticesService } from 'src/app/services/notice/notices.service';

@Component({
    selector: 'app-notices',
    templateUrl: './notices.component.html',
    styleUrls: ['./notices.component.scss'],
})
export class NoticesComponent implements OnInit {
    private destroy$ = new Subject();
    private update$ = new ReplaySubject();

    breadcrumb: IBreadcrumbItem[] = [
        {
            link: '',
            title: 'Notices',
        },
    ];
    loading = false;
    statsResponse: any;

    constructor(private noticesService: NoticesService) {}

    ngOnInit(): void {
        this.update$
            .pipe(
                tap(() => (this.loading = true)),
                switchMap(() =>
                    this.noticesService.getStats().pipe(
                        takeUntil(this.destroy$),
                        tap((res) => {
                            this.statsResponse = res;
                            this.loading = false;
                        }),
                    ),
                ),
            )
            .subscribe();

        this.update$.next();
    }

    getStats() {
        this.update$.next();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
